import { useAppStore } from '@/store/store';
import { CARRIER_PRESETS } from '@freight-cbm/shared-logic';

export function CarrierPresets() {
  const setDimDivisor = useAppStore((s) => s.setDimDivisor);
  const dimDivisor = useAppStore((s) => s.dimDivisor);

  return (
    <div className="card" data-testid="carrier-presets">
      <h3 className="section-title">Carrier Divisor Presets</h3>
      <p style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', marginBottom: 'var(--space-2)' }}>
        Select a carrier to apply its standard dimensional divisor. Metric divisors are in cm³/kg; imperial divisors in in³/lb.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 'var(--space-2)' }}>
        {Object.entries(CARRIER_PRESETS).map(([name, divisor]) => (
          <button
            key={name}
            className={dimDivisor === divisor ? 'btn btn-primary' : 'btn'}
            onClick={() => setDimDivisor(divisor)}
            aria-pressed={dimDivisor === divisor}
            style={{ textAlign: 'left', padding: 'var(--space-2) var(--space-3)' }}
          >
            <div style={{ fontWeight: 'var(--font-weight-medium)' }}>{name}</div>
            <div style={{ fontSize: 'var(--font-size-xs)', opacity: 0.7 }}>÷ {divisor}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
